import React from 'react';
import { SvgIcon } from '@material-ui/core';

/**
 * Dairy cattle / cow face icon (MDI "cow" path).
 * Drop-in replacement for PetsIcon anywhere an animal icon is needed.
 */
const CattleIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M6.5,10A1.5,1.5 0 0,1 8,11.5A1.5,1.5 0 0,1 6.5,13A1.5,1.5 0 0,1 5,11.5A1.5,1.5 0 0,1 6.5,10M17.5,10A1.5,1.5 0 0,1 19,11.5A1.5,1.5 0 0,1 17.5,13A1.5,1.5 0 0,1 16,11.5A1.5,1.5 0 0,1 17.5,10M12,2C10.3,2 8.76,2.6 7.56,3.59L7.14,3.17C7.33,3.09 7.5,2.93 7.5,2.7A0.8,0.8 0 0,0 6.7,1.9A0.8,0.8 0 0,0 5.9,2.7C5.9,2.97 6.11,3.16 6.34,3.18L4.79,4.73C3.68,5.93 3,7.58 3,9.42V11C3,11.55 3.45,12 4,12V16A2,2 0 0,0 6,18H18A2,2 0 0,0 20,16V12C20.55,12 21,11.55 21,11V9.42C21,7.58 20.32,5.93 19.21,4.73L17.66,3.18C17.89,3.16 18.1,2.97 18.1,2.7A0.8,0.8 0 0,0 17.3,1.9A0.8,0.8 0 0,0 16.5,2.7C16.5,2.93 16.67,3.09 16.86,3.17L16.44,3.59C15.24,2.6 13.7,2 12,2M12,4A6,6 0 0,1 18,10H6A6,6 0 0,1 12,4M9,19V22H11V19H9M13,19V22H15V19H13Z" />
  </SvgIcon>
);

export default CattleIcon;
